/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_ViewInputs */

const en_pc_cmp_r_view = /** @type {(inputs: Pc_Cmp_R_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View, search and annotate`)
};

const zh_pc_cmp_r_view = /** @type {(inputs: Pc_Cmp_R_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看、搜索与批注`)
};

/**
* | output |
* | --- |
* | "View, search and annotate" |
*
* @param {Pc_Cmp_R_ViewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_view = /** @type {((inputs?: Pc_Cmp_R_ViewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_ViewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_view(inputs)
	return zh_pc_cmp_r_view(inputs)
});
export { pc_cmp_r_view as "pc.cmp.r.view" }